webpackJsonp([1],{

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce1322b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("qFs+");
function injectStyle (ssrContext) {
  __webpack_require__("fwjG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ce1322b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_observe_visibility__ = __webpack_require__("GBOZ");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('observe-visibility', __WEBPACK_IMPORTED_MODULE_2_vue_observe_visibility__["a" /* ObserveVisibility */]);

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});
window.vm = vm;

/***/ }),

/***/ "fwjG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qFs+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.visibilityChanged),expression:"visibilityChanged"}],attrs:{"id":"om-calculator"},on:{"~click":function($event){_vm.userTouched = true}}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-3 col-md-6 calc__col"},[_c('div',{staticClass:"calc__col__title calc__col__title--orange"},[_vm._v("STRATEGY")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('h5',{staticClass:"slider__title text-yellow"},[_vm._v("Selling Price"),_c('br'),_vm._v(" ("+_vm._s(_vm._f("currency")(_vm.pricing.value))+")")])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('h5',{staticClass:"slider__title text-orange"},[_vm._v("Marketing Budget"),_c('br'),_vm._v(" ("+_vm._s(_vm._f("currency")((_vm.pricing.value - 150 ) * _vm.marketingBudget.value / 100))+")")])])]),_vm._v(" "),_c('div',{staticClass:"row text-center",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"priceBox col-6"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"marginBox",style:({'height': _vm.costPriceHeight +'%'})},[_c('div',{staticClass:"marginBox__budget",style:({'height': _vm.marketingBudget.value +'%'})})]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('vue-slider',_vm._b({scopedSlots:_vm._u([{key:"tooltip",fn:function(tooltip){return _c('span',{staticClass:"vue-slider-tooltip tooltip-yellow"},[_vm._v("\n                  "+_vm._s(_vm._f("currency")(tooltip.value))+"\n                ")])}}]),model:{value:(_vm.pricing.value),callback:function ($$v) {_vm.$set(_vm.pricing, "value", $$v)},expression:"pricing.value"}},'vue-slider',_vm.pricing.options,false))],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('vue-slider',_vm._b({scopedSlots:_vm._u([{key:"tooltip",fn:function(tooltip){return _c('span',{staticClass:"vue-slider-tooltip tooltip-orange"},[_vm._v("\n                  "+_vm._s(_vm._f("toPercent")(tooltip.value))+"\n                ")])}}]),model:{value:(_vm.marketingBudget.value),callback:function ($$v) {_vm.$set(_vm.marketingBudget, "value", $$v)},expression:"marketingBudget.value"}},'vue-slider',_vm.marketingBudget.options,false))],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('vue-slider',_vm._b({scopedSlots:_vm._u([{key:"tooltip",fn:function(tooltip){return _c('span',{staticClass:"vue-slider-tooltip tooltip-carrot"},[_vm._v("\n                  "+_vm._s(_vm._f("toPercent")(tooltip.value))+"\n                ")])}}]),model:{value:(_vm.priceElasticity.value),callback:function ($$v) {_vm.$set(_vm.priceElasticity, "value", $$v)},expression:"priceElasticity.value"}},'vue-slider',_vm.priceElasticity.options,false)),_vm._v(" "),_c('div',{staticClass:"slider__level slider__level--left-bottom"},[_vm._v("Low")]),_vm._v(" "),_c('div',{staticClass:"slider__level slider__level--right-bottom"},[_vm._v("High")]),_vm._v(" "),_vm._m(2)],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-lg-9 col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 calc__col"},[_c('div',{staticClass:"calc__col__title calc__col__title--green"},[_vm._v("MARKETING KPIs")]),_vm._v(" "),_c('div',{staticClass:"column-chart"},[_c('div',{staticClass:"chart chart--horizontal clearfix"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("toPercent")(_vm._f("toFixed")(_vm.conversionRateCalc))))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Conversion rate")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'height': _vm.conversionRateHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("currency")(_vm._f("toFixed")(_vm.cpcCalc))))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Max Cost-per-Click")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'height': _vm.cpcHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm.impressionCalc))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Impressions")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'height': _vm.impressionHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("toPercent")(_vm.ctrCalc)))]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'height': _vm.ctrHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm.clicksCalc))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Clicks")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'height': _vm.clickHeight +'%'})})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 calc__col"},[_c('div',{staticClass:"calc__col__title calc__col__title--blue"},[_vm._v("PERFORMANCE")]),_vm._v(" "),_c('div',{staticClass:"column-chart column-chart--results"},[_c('div',{staticClass:"chart chart--vertical clearfix"},[_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("currency")(_vm.turnoverCalc)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Turnover")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'width': _vm.turnoverHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("currency")(_vm.profitCalc)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Profit")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'width': _vm.profitHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("currency")(_vm.marketingSpendCalc)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Marketing Spend")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'width': _vm.marketingSpendHeight +'%'})})])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',{staticClass:"bar"},[_c('span',{staticClass:"percent"},[_vm._v(_vm._s(_vm._f("currency")(_vm.netProfitCalc)))]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Net Profit")]),_vm._v(" "),_c('div',{staticClass:"item-progress",style:({'width': _vm.netProfitHeight +'%'})})])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avgBox"},[_c('div',{staticClass:"avgBox__label"},[_vm._v("Average market price")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"marginalBox"},[_c('div',{staticClass:"marginalBox__label"},[_vm._v("Marginal costs (€ 150)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"slider__title slider__title--center slider__title--bottom text-carrot"},[_c('span',[_vm._v("Price Elasticity")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"title"},[_vm._v("Ad"),_c('br'),_vm._v(" Click-through-Rate")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__("O4Lo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'om-calculator',
  data: function data() {
    return {
      inViewport: false,
      userTouched: false,
      costPrice: {
        min: 150,
        max: 200
      },
      conversionRate: {
        min: 0.1,
        max: 7
      },
      cpcValue: {
        min: 0,
        max: 1
      },
      impression: {
        min: 0,
        max: 20000
      },
      ctrValue: {
        min: 1,
        max: 8
      },
      clicks: {
        min: 0,
        max: 800
      },
      pricing: {
        value: 165,
        options: {
          direction: 'vertical',
          eventType: 'auto',
          width: 6,
          height: 235,
          dotSize: 16,
          min: 150,
          max: 200,
          interval: 1,
          show: true,
          speed: 0.5,
          tooltip: 'hover',
          tooltipDir: 'left',
          lazy: false,
          sliderStyle: [],
          processStyle: {
            'backgroundColor': '#f1c40f'
          },
          piecewiseActiveStyle: null,
          piecewiseStyle: null,
          tooltipStyle: {
            'backgroundColor': '#f1c40f',
            'borderColor': '#f1c40f'
          }
        }
      },
      marketingBudget: {
        value: 50,
        options: {
          direction: 'vertical',
          eventType: 'auto',
          width: 6,
          height: 235,
          dotSize: 16,
          min: 30,
          max: 100,
          interval: 1,
          show: true,
          speed: 0.5,
          tooltip: 'hover',
          tooltipDir: 'right',
          lazy: false,
          sliderStyle: [],
          processStyle: {
            'backgroundColor': '#f39c12'
          },
          piecewiseActiveStyle: null,
          piecewiseStyle: null,
          tooltipStyle: {
            'backgroundColor': '#f39c12',
            'borderColor': '#f39c12'
          }
        }
      },
      priceElasticity: {
        value: 50,
        options: {
          direction: 'horizontal',
          eventType: 'auto',
          width: 'auto',
          height: 6,
          dotSize: 16,
          min: 30,
          max: 100,
          interval: 1,
          show: true,
          speed: 0.5,
          tooltip: false, // 'hover'
          tooltipDir: 'top',
          tooltipStyle: {
            'backgroundColor': '#e67e22',
            'borderColor': '#e67e22'
          },
          lazy: false,
          sliderStyle: [],
          processStyle: {
            'backgroundColor': '#e67e22'
          },
          piecewiseActiveStyle: null,
          piecewiseStyle: null
        }
      }
    };
  },

  computed: {
    marketingBudgetCalc: function marketingBudgetCalc() {
      return (this.pricing.value - this.costPrice.min) * this.marketingBudget.value / 100;
    },
    conversionRateCalc: function conversionRateCalc() {
      if (this.pricing.value - 175 < 0) {
        return (0.025 - 0.045 * ((this.pricing.value - 175) / 25) * (this.priceElasticity.value / 100)) * 100;
      } else {
        return (0.025 - 0.024 * ((this.pricing.value - 175) / 25) * (this.priceElasticity.value / 100)) * 100;
      }
    },
    cpcCalc: function cpcCalc() {
      return Math.min((this.conversionRateCalc * this.marketingBudgetCalc / 100).toFixed(3), 1);
    },
    impressionCalc: function impressionCalc() {
      return (this.cpcCalc / this.cpcValue.max * this.impression.max).toFixed(0);
    },
    ctrCalc: function ctrCalc() {
      if (this.pricing.value - 175 < 0) {
        return ((0.03 - 0.05 * ((this.pricing.value - 175) / 25) * (this.priceElasticity.value / 100)) * 100).toFixed(2);
      } else {
        return ((0.03 - 0.02 * ((this.pricing.value - 175) / 25) * (this.priceElasticity.value / 100)) * 100).toFixed(2);
      }
    },
    clicksCalc: function clicksCalc() {
      return (this.ctrCalc * this.impressionCalc / 100).toFixed(0);
    },
    turnoverCalc: function turnoverCalc() {
      return (this.clicksCalc * (this.conversionRateCalc / 100) * this.pricing.value).toFixed(2);
    },
    profitCalc: function profitCalc() {
      return (this.clicksCalc * (this.conversionRateCalc / 100) * (this.pricing.value - this.costPrice.min)).toFixed(2);
    },
    marketingSpendCalc: function marketingSpendCalc() {
      return (this.clicksCalc * this.cpcCalc).toFixed(2);
    },
    netProfitCalc: function netProfitCalc() {
      return (this.profitCalc - this.marketingSpendCalc).toFixed(2);
    },
    conversionRateHeight: function conversionRateHeight() {
      return (this.conversionRateCalc - this.conversionRate.min) * 100 / (this.conversionRate.max - this.conversionRate.min);
    },
    cpcHeight: function cpcHeight() {
      return (this.cpcCalc - this.cpcValue.min) * 100 / (this.cpcValue.max - this.cpcValue.min);
    },
    impressionHeight: function impressionHeight() {
      return (this.impressionCalc - this.impression.min) * 100 / (this.impression.max - this.impression.min);
    },
    ctrHeight: function ctrHeight() {
      return (this.ctrCalc - this.ctrValue.min) * 100 / (this.ctrValue.max - this.ctrValue.min);
    },
    clickHeight: function clickHeight() {
      return (this.clicksCalc - this.clicks.min) * 100 / (this.clicks.max - this.clicks.min);
    },
    costPriceHeight: function costPriceHeight() {
      return (this.pricing.value - this.costPrice.min) * 100 / (this.costPrice.max - this.costPrice.min);
    },
    turnoverHeight: function turnoverHeight() {
      return this.turnoverCalc * 100 / 5200;
    },
    profitHeight: function profitHeight() {
      return this.profitCalc * 100 / 420;
    },
    marketingSpendHeight: function marketingSpendHeight() {
      return this.marketingSpendCalc * 100 / 420;
    },
    netProfitHeight: function netProfitHeight() {
      return this.netProfitCalc * 100 / 105;
    }
  },
  filters: {
    currency: function currency(value) {
      if (!value) return '';
      value = '€ ' + value;
      return value;
    },
    toPercent: function toPercent(value) {
      if (!value) return '';
      value += '%';
      return value;
    },
    toFixed: function toFixed(value) {
      if (!value) return '';
      return value.toFixed(2);
    }
  },
  methods: {
    visibilityChanged: function visibilityChanged(isVisible, entry) {
      this.inViewport = isVisible;
    },

    handleScroll: function handleScroll() {}
  },
  components: {
    vueSlider: __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  },
  created: function created() {
    var _this = this;

    this.handleScroll = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function (e) {
      if (_this.inViewport && !_this.userTouched) {
        _this.pricing.value = Math.floor(Math.random() * (180 - 165)) + 165;
      }
    }, 50);

    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.1ad94153494dd4dd74df.js